import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ErrorService } from "@services/error.service";
import { ExpedienteService } from "@services/expediente.service";
import { SessionService } from "@services/session.service";
import { PrestadorService } from "@services/prestador.service";
import { Expediente } from "@models/expediente.model";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";
import Funcionalidades from "@shared/enums/funcionalidades.enum";
import { Location } from "@angular/common";
import { StateService } from "@services/state.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Licencia } from "@models/licencia.model";
import { TerminologiaService } from '@services/terminologia.service';
import { TipoDocumento } from "@models/tipo-documento.model";
import { Mensajes } from "@shared/enums/mensajes.enum";
import SiNo from "@shared/enums/si-no.enum";

@Component({
    selector: "app-plantillas-documentos",
    templateUrl: "./plantillas-documentos.component.html",
    styleUrls: ["./plantillas-documentos.component.scss"],
})
export class PlantillaDocumentoComponent extends BaseFuncionalidadComponent {
    constructor(
        sessionService: SessionService,
        route: ActivatedRoute,
        location: Location,
        router: Router,
        stateService: StateService,
        private errorService: ErrorService,
        private expedienteService: ExpedienteService,
        private prestadorService: PrestadorService,
        private terminologiaService: TerminologiaService,
        private sanitizer: DomSanitizer
    ) {
        super(route, sessionService, location, router, stateService);
    }

    licencias: Licencia[] = []; // Variable que guarda la información de las licencias medicas que se muestran en la tabla

    mostrarModalAprobacion = false; // Variable que maneja el renderizado del modal de aprobación de expediente
    mostrarModalRechazo = false; // Variable que maneja el renderizado del modal de rechazo de expediente
    mostrarModalEnvioAntecedentes = false; // Variable que maneja el renderizado del modal de envío de antecedentes
    mostrarModalAprobacionProrroga = false; // Variable que maneja el renderizado del modal de aprobación de la prórroga
    mostrarModalRechazoProrroga = false; // Variable que maneja el renderizado del modal de rechazo de la prórroga
    motivoProrroga: string = "Motivo 1";
    mostrarModalFirmarResolucion = false; // Variable que maneja el renderizado del modal de firmar la resolución de la sanción
    mostrarModalCerrarExpediente = false;
    mostrarModalPreviewResolucion = false; // Variable que maneja el renderizado del modal preview del pdf de resolución
    urlArchivoProrroga: string;
    motivoRechazoProrroga: string;

    motivoRechazo: string; // variable que guarda el motivo de rechazo del expediente
    mensajeExito: string; // variable que guarda el mensaje de exito en la acción del expediente
    expedientes: Expediente[] = []; // Variable que guarda la información de los expedientes que se muestran en la tabla
    pdfResolucionBase64: string; // Documento pdf de la resolucion en base64
    pdfResolucionUrl: SafeResourceUrl; // Url del documento pdf de la resolucion en base64
    tiposDocumento: TipoDocumento[] = []
    documentoUrl: SafeResourceUrl;
    mostrarModal: boolean = false;
    rutaTipoDocumento: string | null;
    tipoSeleccionado: TipoDocumento;

    async ngOnInit() {
        await this.obtenerExpedientes();
        await this.obtenerTiposDocumentos();
    }

    get mensajeSinPermisos(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_funcionalidad);
    }

    get tipos() {
      return this.tiposDocumento.filter(td => td.requerido === SiNo.si);
    }

    async obtenerExpedientes() {
        this.isLoading = true;
        try {
            const promesas = this.construirPromesasPorFuncionalidad();
            const [expedientes, prestador] = await Promise.all(promesas);

            this.expedientes = expedientes;
            if (prestador) {
                this.prestador = prestador;
                this.stateService.setPrestador(this.prestador);
                if (expedientes.length > 0) {
                    const exp = this.expedientes[0];
                    this.prestador.email_fiscalizacion = exp.prestador.email_fiscalizacion;
                }
            }

        } catch (error) {
            this.errorService.handle(error, "Error al obtener los expedientes.");
        } finally {
            this.isLoading = false;
        }
    }

    private construirPromesasPorFuncionalidad(): Promise<any>[] {
        const rutSinDV = this.usuario.getRutSinDV();

        switch (this.idFuncionalidad) {
            case Funcionalidades.ver_plantillas: // Expedientes Prestador
                return [
                    this.expedienteService.obtenerExpedientesPorRut(),
                    this.prestadorService.obtenerInformacion(rutSinDV),
                ];
            default: throw new Error("Funcionalidad incorrecta.");
        }
    }

    async goVerDocumentos(tipo: any) {
        try {
            console.log('tipo seleccionado:', tipo);
            this.tipoSeleccionado = tipo;
            this.descargarDocumento(tipo);
        } catch (error) {
            this.errorService.handle(error, 'Error al obtener el documento');
        }
    }

    private descargarDocumento(tipo: TipoDocumento) {
        const tipoDocumento = this.tiposDocumento.find(td => td.codigo === tipo.codigo);
        const url = tipoDocumento.ruta;
        const a = document.createElement('a');
        a.href = url;
        a.download = tipoDocumento.nombre;
        a.target = '_blank';
        a.click();
    }

    async obtenerTiposDocumentos() {
        this.isLoading = true;
        try {
            this.tiposDocumento = this.terminologiaService.obtenerTiposDocumentoLicencia();
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al obtener los tipos de documento.");
        } finally {
            this.isLoading = false;
        }
    }

}
